/* Black Friday 2.0 — offer config.

   Option 1  Necklace only ............ $25.95  (35% off $39.95)
   Option 2  Necklace + 1 flavour
               one-time ............... $45.95  ($25.95 + $20.00)
               Subscribe & Save ....... $39.95  ($25.95 + $14.00) + 1 FREE flavour

   CURRENCY RULE (do not break this):
   - Prices inside the widget's JSON (flavor/necklace price, compare_at_price,
     sellingPlans[].price) are ALREADY in the visitor's currency, converted and
     rounded by Shopify Markets. Never overwrite them with fixed numbers.
   - The cfg *Off values are SHOP-CURRENCY amounts. The widget multiplies them
     by the market's exchange rate, exactly as Shopify does with the
     fixed-amount discount codes, so the price shown matches what the cart
     charges in every currency. Never derive them from prices read off the page.

   The free 2nd flavor is gated on Subscribe & Save by bf-offer-v2.js, which
   also forces option 1 down to zero flavours (the widget's own config floor
   is 1). */
(function () {
  'use strict';
  if (location.pathname.indexOf('breathefree-2-0-resistance-necklace-early-black-friday') === -1) return;

  var PLAN_ID = 6273892404;              /* 40% off order 1, 20% after */
  var FLAVOUR_PRODUCT = 15410765922356;  /* 2.0 Flavor Refills — what the template already uses */

  /* 2.0 Flavor Refills (Gift) — product 15447894196276, all variants $0.00. */
  var GIFT_PRODUCT = 15447894196276;
  var GIFT = [
    [67889269440564, 'Strawberry Twist'], [67889269342260, 'Cool Mint'],
    [67889269669940, 'Arctic Menthol'],   [67889269375028, 'Watermelon Splash'],
    [67889269506100, 'Blueberry Ice'],    [67889269637172, 'Mango Burst'],
    [67889269407796, 'Coffee Rush'],      [67889269473332, 'Raspberry Zing'],
    [67889269604404, 'Cinnamon Spice'],   [67889269538868, 'Lemon Breeze'],
    [67889269571636, 'Plain']
  ];
  var MYSTERY_VARIANT = 67889269506100;

  /* shop-currency amounts off, matching discount codes NBF-N / NBF-R / NBF-RS */
  var NECKLACE_OFF   = '10.00';
  var REFILL_OFF     = '13.95';
  var REFILL_SUB_OFF = '7.97';
  var GIFT_VALUE     = '29.95';   /* worth shown for the free flavour */

  function patch(node) {
    if (!node || node.getAttribute('data-bf2-patched')) return;
    var d; try { d = JSON.parse(node.textContent); } catch (e) { return; }
    if (!d || !d.cfg || !d.necklace || !d.flavor) return;

    if (d.flavor.id && d.flavor.id !== FLAVOUR_PRODUCT) {
      console.warn('[BF] this page is not on 2.0 Flavor Refills (' + d.flavor.id + ') - check the section setting');
    }

    /* paid flavours: leave every price as the theme rendered it, so the
       visitor's own currency survives. Only flatten compare-at, otherwise the
       "was" total adds up $45.45 a flavour and stops being believable. */
    (d.flavor.variants || []).forEach(function (v) {
      v.compare_at_price = v.price;
      (v.sellingPlans || []).forEach(function (p) {
        if (p.recurringPrice == null) p.recurringPrice = Math.round(v.price * 0.8);
      });
    });

    /* free flavour comes from the 2.0 $0 gift product */
    d.flavorGiftProductId = GIFT_PRODUCT;
    d.flavorGift = GIFT.map(function (r) { return { id: r[0], title: r[1], available: true }; });
    d.cfg.mysteryVariantId = String(MYSTERY_VARIANT);

    /* gifts: the mouthpiece is dropped from the offer entirely. What is left
       is the free flavour (option 2 + subscription) and the ebook bundle
       (option 2), so option 1 stays a clean necklace-only buy. */
    d.gifts = (d.gifts || []).filter(function (g) {
      return !/mouthpiece/i.test((g && (g.title || g.productTitle)) || '');
    });
    (d.gifts || []).forEach(function (g) {
      if (!g) return;
      if (/mystery|flavor refill|flavour refill/i.test(g.title || '')) {
        g.variantId = MYSTERY_VARIANT;
        g.productId = GIFT_PRODUCT;
        g.price = 0;
        g.value = GIFT_VALUE;      /* shop currency - the widget converts it */
        g.unlock = 'plus_sub';     /* option 2 AND Subscribe & Save */
      } else {
        g.unlock = 'plus';         /* option 2 only */
      }
    });

    d.cfg.sellingPlanId = String(PLAN_ID);
    d.cfg.necklaceOff  = NECKLACE_OFF;
    d.cfg.refillOff    = REFILL_OFF;
    d.cfg.refillSubOff = REFILL_SUB_OFF;
    d.cfg.pageCodes = 'NBF-N,NBF-R,NBF-RS';
    d.cfg.preselected = 'reset-plus';
    d.cfg.subDefault = true;
    d.cfg.subTitle = 'Subscribe & Save';
    d.cfg.subText = 'Refills every 28 days · get a 2nd flavor free · cancel anytime';
    d.cfg.giftsHeading = 'Your free gifts';

    d.cfg.b1 = {
      title: 'Just the Necklace',
      subtitle: 'BreatheFree 2.0 · 35% off',
      refills: 0,              /* the widget floors this at 1 — bf-offer-v2.js forces it back */
      free: 0,
      badge: ''
    };
    d.cfg.b2 = {
      title: 'Necklace + Flavor',
      subtitle: 'BreatheFree 2.0 · 1 flavor · 2nd free on subscription',
      refills: 1,
      free: 1,
      badge: 'BEST VALUE • SAVES {saved} • 2ND FLAVOR FREE'
    };

    if (d.cfg.kc) d.cfg.kc.enable = false;

    node.textContent = JSON.stringify(d);
    node.setAttribute('data-bf2-patched', '1');
    node.setAttribute('data-bf-patched', '1');
  }

  var seen = document.querySelector('script[data-rsb-data]');
  if (seen) patch(seen);
  new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var a = recs[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('script[data-rsb-data]')) patch(n);
        else if (n.querySelector) { var q = n.querySelector('script[data-rsb-data]'); if (q) patch(q); }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  var st = document.createElement('style');
  st.textContent = '.rsb .rsb-check{color:#fff!important}.rsb .rsb-check svg{color:#fff!important;stroke:#fff!important;opacity:1!important}';
  (document.head || document.documentElement).appendChild(st);
  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(st); });
})();